<div *ngIf="loading" style="height: 500px">
  <app-loading-page></app-loading-page>
</div>

<ng-container *ngIf="!loading">
  <div class="modal-header" style="align-items: center">
    <i class="far fa-lg fa-filter mr-2"></i>
    <h3 class="modal-title">Filtro</h3>
    <button type="button" class="close" (click)="closeModalEmit(); cancelFilter()" aria-label="Close">
      <i aria-hidden="true" class="fas fa-xmark"></i>
    </button>
  </div>

  <div class="modal-body">
    <h3 class="title-filter mb-3">Filtros</h3>

    <!-- FILTRO REMOVIDAS E RECUSADAS -->
    <div *ngIf="removalFilter">
      <div class="custom-control custom-checkbox p-0 mb-4">
        <input
          type="checkbox"
          [(checked)]="checkRemovalFilter"
          (change)="checkRemovalFilter = !checkRemovalFilter"
          class="custom-control-input pointer mr-2"
          id="removeFilter"
          style="font-size: 20px; position: relative"
        />
        <label class="custom-control-label cursor-pointer" for="removeFilter"
          >Mostrar na lista de sinalizações removidas</label
        >
      </div>
    </div>
    <!-- FILTRO REMOVIDAS E RECUSADAS -->

    <!-- INPUT DAS OPÇÕES DE FILTRO, ASSIM QUE ADICIONADAS -->
    <ng-container *ngFor="let option of usedFilterOptions | keyvalue: originalOrder">
      <app-multiple-select
        *ngIf="option?.value?.check"
        [option]="option?.value"
        [name]="option.key"
        (emitSelected)="receiveSelected($event, option.key)"
      ></app-multiple-select>
    </ng-container>
    <!-- INPUT DAS OPÇÕES DE FILTRO, ASSIM QUE ADICIONADAS -->

    <h3 *ngIf="!checkOptionBool" class="text-filter">
      Nenhum filtro selecionado. Para adicionar, clique em <i class="fas fa-lg fa-circle-plus mr-2"></i>
      <span class="span-filter"> NOVO FILTRO</span> abaixo.
    </h3>
  </div>

  <div class="modal-footer justify-content-between">
    <a
      (click)="saveTemp(); openModal(addRemoveOption)"
      class="btn btn-link btn-popup d-flex align-items-center justify-content-center p-0"
      style="height: 30px"
    >
      <i class="fas fa-lg fa-circle-plus mr-2"></i> NOVO FILTRO
    </a>
    <button type="button" class="btn btn-primary" (click)="sendFilter()">Filtrar</button>
  </div>
</ng-container>

<!-- Template Modal Adicionar/Remover Options Filtro-->
<ng-template #addRemoveOption>
  <div class="modal-header" style="align-items: center">
    <h3 class="modal-title">Adicionar/Remover Filtros</h3>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
      <i aria-hidden="true" class="fas fa-xmark"></i>
    </button>
  </div>

  <div class="modal-body">
    <ng-container *ngFor="let option of usedFilterOptions | keyvalue: originalOrder">
      <div class="custom-control custom-checkbox my-3 ml-3" *ngIf="!option?.value?.title || option?.value?.view">
        <input
          class="custom-control-input"
          name="selectList"
          style="z-index: 300"
          (change)="changeCheckFilter(option.key)"
          type="checkbox"
          [id]="'filter' + option.key"
          [checked]="filterOptionsAux.get(option.key) ?? false"
        />
        <label class="custom-control-label cursor-pointer pl-3" [for]="'filter' + option.key">
          {{ option?.value?.title ?? (option.key | enumText: 'FilterOptionsEnum') }}
        </label>
      </div>
    </ng-container>
  </div>

  <div class="modal-footer justify-content-between">
    <button
      type="button"
      class="btn btn-outline-primary"
      style="margin: 0em"
      (click)="closeModal()"
    >
      Cancelar
    </button>
    <button type="button" class="btn btn-primary" (click)="saveCheckFilter(); closeModal()">SALVAR</button>
  </div>
</ng-template>
<!-- Template Modal Adicionar/Remover Options Filtro -->
